module.exports = __webpack_public_path__ + "static/media/avatar_assistant.da873092.svg";